(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AgentServiceItemAccess', AgentServiceItemAccess);

    AgentServiceItemAccess.$inject = ['$resource'];

    function AgentServiceItemAccess($resource) {
        var resourceUrl = 'api/agent-service-item-accesses/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
